<template>
<v-fab-transition>
    <v-row class="fill-height">
        <v-col>
            <v-sheet height="64">
                <v-toolbar flat>
                    <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                        Today
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="prev">
                        <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="next">
                        <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-menu bottom right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right> mdi-menu-down </v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="type = 'day'">
                                <v-list-item-title>Day</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'week'">
                                <v-list-item-title>Week</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'month'">
                                <v-list-item-title>Month</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = '4day'">
                                <v-list-item-title>4 days</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
                <v-calendar ref="calendar" v-model="focus" color="primary" :events="thisEvents" :event-color="getEventColor" :type="type" @click:event="eventDetails" @click:more="viewDay" @click:date="viewDay" @change="updateRange"></v-calendar>
                <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                    <v-card color="grey lighten-4" min-width="350px" flat>
                        <v-toolbar :color="selectedEvent.color" dark>
                            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <span v-html="selectedEvent.details"></span>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text color="secondary" @click="selectedOpen = false">
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-sheet>
        </v-col>
    </v-row>
</v-fab-transition>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    data: function () {
        return {
            focus: "",
            type: "month",
            typeToLabel: {
                month: "Month",
                week: "Week",
                day: "Day",
                "4day": "4 Days",
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            thisEvents: [],
            colors: [
                "blue",
                "indigo",
                "deep-purple",
                "cyan",
                "green",
                "orange",
                "grey darken-1",
            ],
            names: [
                "Meeting",
                "Holiday",
                "PTO",
                "Travel",
                "Event",
                "Birthday",
                "Conference",
                "Party",
            ],
        };
    },
    mounted() {

        this.$refs.calendar.checkChange();
        this.updateCalendarEvents();
    },
    computed: mapState({
        events: (state) => state.events?.events?.results,
    }),
    methods: {
        setShowDate(d) {
            this.showDate = d;
        },
        viewDay({
            date
        }) {
            this.focus = date;
            this.type = "day";
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = "";
        },
        prev() {
            this.$refs.calendar.prev();
        },
        next() {
            this.$refs.calendar.next();
        },
        eventDetails(e) {
            this.$router.push(`/event/details/${e.event.slug}`);
        },
        async updateRange() {
            this.updateCalendarEvents();
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a;
        },
        updateCalendarEvents() {
            if (!this.events) {
                return;
            }
            this.thisEvents = []
            for (const event of this.events) {
                let newEvent = {
                    slug: event.event_slug,
                    name: event.event_title,
                    // start: parseDateTime(event.event_datetime_start),
                    start: new Date(event.event_datetime_start),

                    color: this.colors[this.rnd(0, this.colors.length - 1)],
                    timed: false,
                };
                if (event.event_datetime_end) {
                    // newEvent["end"] = parseDateTime(event.event_datetime_end)
                    newEvent["end"] = new Date(event.event_datetime_end)
                }
                this.thisEvents.push(newEvent);
            }
        },
    },
};
</script>
